import { render, staticRenderFns } from "./edit-production.vue?vue&type=template&id=5a6339db&scoped=true"
import script from "./edit-production.vue?vue&type=script&lang=js"
export * from "./edit-production.vue?vue&type=script&lang=js"
import style0 from "./edit-production.vue?vue&type=style&index=0&id=5a6339db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6339db",
  null
  
)

export default component.exports